var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-9" }, [
        _c("p", [_vm._v(_vm._s(_vm.statusText))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.formatOutgoingNumber))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.contactList))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.start))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.stop))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.interval))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.maxMessages))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.createdAt))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.updatedAt))]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Status:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Sender:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Contact List:"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Start:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Stop:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Minimal interval:"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Messages limit:"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Created:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Updated:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }